import {Form, Modal} from "react-bootstrap";
import {type FormEvent, forwardRef, useImperativeHandle, useState} from "react";
import {useTranslation} from "react-i18next";


export interface TerminalPasswordDialogProps {
    onEnterPassword?: (password: string) => void,
    onCancel?: () => void,
}

export interface TerminalPasswordDialogRef {
    show: () => void,
}

const TerminalPasswordDialog = forwardRef<TerminalPasswordDialogRef, TerminalPasswordDialogProps>(
    (props, ref) => {
        const {t} = useTranslation();
        let disposed = false;

        const [visible, setVisible] = useState(false);

        useImperativeHandle(ref, () => ({
            show() {
                disposed = false;
                setVisible(true);
            }
        }));

        function onSubmit(e: FormEvent<HTMLFormElement>) {
            e.preventDefault();
            const form = e.currentTarget as HTMLFormElement;
            const formData = new FormData(form);

            if (props.onEnterPassword) {
                props.onEnterPassword(formData.get('password')! as string);
            }

            disposed = true;
            form.reset();

            setVisible(false);
        }

        function onReset(e: FormEvent<HTMLFormElement>) {
            e.preventDefault();

            setVisible(false);
            onHide();

            if (!disposed && props.onCancel) {
                props.onCancel();
            }
        }

        function onHide() {
        }

        return (
            <Modal
                show={visible} className="modal" id="enter-password-modal"
                onHide={onHide}
            >
                <Modal.Header>
                    <h6 className="modal-title text-primary">{t("terminal.passwordRequired")}</h6>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={onSubmit} onReset={onReset}>
                        <label htmlFor="password" className="mb-2">
                            <h6 className="modal-title text-secondary">{t("terminal.youWillNeedThePasswordForYourPrivateKey")}</h6>
                        </label>
                        <input type="password" name="password" className="form-control"/>
                        <div className="modal-footer border-0 pe-0 pb-0">
                            <button type="submit" className="button_blue px-4 rounded-3 me-0"
                                    style={{float: "right"}}>
                                {t("common.confirm")}
                            </button>
                            <button className="button_red px-4 rounded-3" style={{float: "right"}} type="reset">
                                {t("common.cancel")}
                            </button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        );
    }
);

export default TerminalPasswordDialog;